import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Wrapper } from '../../components/wrapper.component';
import { LogisticView, LogisticViewExcludedIdMakers, LogisticViewNames, logisticsViewOptions, programLogsticsDisplayOptionsNestedFieldCheckGroups } from '../program/program.logistics.display-options';
import { loadLocal, saveLocal } from '../../helpers/helpers';
import { Dictionary } from '@ngrx/entity';
import { LabelMaps, JoiEvent } from 'globals/store/events.data';
import { makeEmptyLabelMaps } from '../../store/events.era';
import { TagPanelData } from 'globals/store/tags.data';
import {filterActions, filterPageTypes } from '../../store/filters.era';
import { exhibitorStandIdsByAllProgramIdsReselector } from '../../store/reselectors/exhibitors.reselector';
import { filteredLogisticsProgramsReselector, programSessionsActivitesMegaTagReselector } from '../../store/reselectors/programs.reselector';
import { FiltersDialogComponent } from '../../components/filters/filters-dialog.component';
import { FilterDialogComponentParams } from '../../components/filters/filters-ui.models';
import { NestedChecksDialogData, NestedChecksReturnData, NestedChecksDialogComponent } from '../../components/wizards/nested-checks.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { Program, Session } from 'globals/store/programs.data';
import { LogisticsViewComponent } from './logistics-view.component';
import { sessionMapReselector } from '../../store/reselectors/sessions.reselector';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { TopMenuComponent } from '../program/top.menu';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { traceNames } from 'src/app/services/performance.tracking.data';


@Component({
    selector: 'logistics-views',
    templateUrl: './logistics-views.html',
    styleUrls: ['./logistics-views.scss', '../../page.scss'],
    standalone: true,
    imports: [TopMenuComponent, CommonModule, IconComponent, IconTextComponent, MobileMenuComponent, LoaderPaneFragmentComponent, JoiNavWrapper, LogisticsViewComponent],
})
export class LogisticsViewsComponent extends Wrapper<LogisticsViewsComponent> {
  selectedViewMode: LogisticView = 'All'
  viewModes: LogisticView[] = ['All', 'Venues', 'Setups', 'Exhibitions', 'Staging', 'Assets', 'Catering']
  viewModeNames = LogisticViewNames
  programsLoaded: boolean
  traceNames = traceNames;
  labelMaps: LabelMaps = makeEmptyLabelMaps()
  expandedStates = {}
  exhibitorStandIdsByProgramId: Dictionary<string[]> = {}
  excludedFieldIds: string[] = []
  programs: Program[]
  actualFilterCount = 0
  tagDataMap: Dictionary<TagPanelData>
  is_logistics = true
  currentEvent: JoiEvent
  sessionMap: Dictionary<Session> = {}

  @ViewChild('logisticsView') logisticsView: LogisticsViewComponent<JoiEvent>

  page_name = 'logistics_views'

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.store.dispatch(filterActions.clearFilterGroup('programLogistics'))
    this.changeView('All')
    this.selectProp(sessionMapReselector, null, 'sessionMap')
    this.uiService.changePageTitle("Production View",true)
    this.subProp(this.store.select(exhibitorStandIdsByAllProgramIdsReselector), 'exhibitorStandIdsByProgramId')
    this.subCallback(this.store.select('events', 'event'), currentEvent => {
      this.currentEvent = currentEvent;
    })
    this.subProp(this.store.select(filteredLogisticsProgramsReselector), 'programs')
    this.subProp(this.store.select('programs','loaded'), 'programsLoaded')
    this.subProp(this.store.select('events', 'labelMaps'), 'labelMaps')
    this.subProp(this.store.select('filters', filterPageTypes.programLogistics, 'count'), 'actualFilterCount')
    this.subProp(this.store.select(programSessionsActivitesMegaTagReselector), 'tagDataMap')
    this.subCallback(this.store.select('permissions', 'access', 'types'), types => 
      this.is_logistics = (types.includes('logistics') && !types.includes('program'))
    )
  }

  expandAll() {
    this.logisticsView.expandAll()
  }

  collapseAll() {
    this.logisticsView.collapseAll()
  }

  async filter() {
    const filterGroupings = await this.filtersService.buildProgramLogisticsFilterUI()
    const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.programLogistics, filterGroupings }}
    await this.openDialogGetResult(FiltersDialogComponent, params);
  }

  async editDisplayOptions() {
      
    const nestedCheckGroups = jsonCopyObject(programLogsticsDisplayOptionsNestedFieldCheckGroups)
    const data: NestedChecksDialogData = {
      title: 'Display options',
      successLabel: 'SAVE',
      deselectedIds: Array.from(this.excludedFieldIds),
      backgroundColor: this.uiService.labelsByType.event.color,
      nestedCheckGroups,
      views: logisticsViewOptions
    }
    const result = await openDialogGetResult<NestedChecksReturnData>(this.dialog, NestedChecksDialogComponent, { width: '480px', disableClose: true, data })

    if (!result) return
    
    this.excludedFieldIds = [...result.deselectedIds]
    saveLocal(`logisticView${this.selectedViewMode}`, this.excludedFieldIds)
    console.log(this.excludedFieldIds)
  }


  changeView(viewMode: LogisticView) {
    this.selectedViewMode = viewMode
    const defaultIds = LogisticViewExcludedIdMakers[viewMode]()

    this.excludedFieldIds = loadLocal(`logisticView${viewMode}`, defaultIds)
    console.log({ excludedFieldIds: this.excludedFieldIds, defaultIds })

  }

}